// const variations = repeatIndex(40).map(i => i * 2.5);

import type { ZodSchema } from "zod";
import { z } from "zod";
import { type ColorValue, colorValueZodSchema } from "./color-value";

// type ColorVariation = typeof variations[]
const colorVariations = [
    "value",
    "light00",
    "light05",
    "light10",
    "light15",
    "light20",
    "light25",
    "light30",
    "light35",
    "light40",
    "light45",
    "light50",
    "light55",
    "light60",
    "light65",
    "light70",
    "light75",
    "light80",
    "light85",
    "light90",
    "light91",
    "light92",
    "light93",
    "light94",
    "light95",
    "light96",
    "light97",
    "light98",
    "light99",
    "light100",
] as const;
type ColorVariation = (typeof colorVariations)[number];

const colorVariationsZodSchemaGenerator = () => {
    const items = colorVariations.reduce(
        (variations, variation) => {
            variations[variation] = colorValueZodSchema;
            return variations;
        },
        {} as Record<ColorVariation, ZodSchema<ColorValue>>,
    );
    return z.object(items);
};

const colorVariationSetZodSchema = colorVariationsZodSchemaGenerator();
type ColorVariationSet = z.infer<typeof colorVariationSetZodSchema>;

export { colorVariations, colorVariationSetZodSchema };
export type { ColorVariation, ColorVariationSet };
